import { graphql } from '@eluve/graphql.tada';

export const tenantUserOptionFragment = graphql(`
  fragment TenantUserOption on Users @_unmask {
    __typename
    id
    firstName
    lastName
    email
  }
`);

export const searchTenantUsersQuery = graphql(
  `
    query searchTenantUsers(
      $filter: TenantUsersBoolExp
      $limit: Int
      $orderBy: [TenantUsersOrderBy!]
    ) {
      tenantUsers(where: $filter, limit: $limit, orderBy: $orderBy) {
        __typename
        tenantId
        userId
        user {
          ...TenantUserOption
        }
      }
    }
  `,
  [tenantUserOptionFragment],
);
